export const EMPTY_DELETE = 'empty-delete';
export const EMPTY_BACKSPACE = 'empty-backspace';
export const REMOVE_BLOCK_STYLE = 'remove-block-style';
